const FONT_PRIMARY =  ["Poppins", "sans-serif"].join(",");

const typography = {
  fontFamily: FONT_PRIMARY,
};

export default typography;
